import React from "react";
import FlipChar from "./FlipChar";

/**
 * FlipCell - converts a string into FlipChar elements (one per character).
 * Pads/truncates to a given width if provided.
 *
 * Props:
 *  - value: string
 *  - width: number (optional) - fixed char count; if provided, value will be padded/truncated
 */
const FlipCell = ({ value = "", width = null }) => {
  let str = String(value ?? "").toUpperCase();

  if (width !== null && Number.isInteger(width)) {
    if (str.length > width) str = str.slice(0, width);
    else str = str.padEnd(width, " ");
  }

  const chars = Array.from(str);

  return (
    <div className="flip-cell" role="presentation">
      {chars.map((c, idx) => (
        <FlipChar key={idx + ":" + c} char={c} />
      ))}
    </div>
  );
};

export default FlipCell;
